<!-- =========================================================================================
    File Name: Listusers.vue
    Description: Ag Grid table
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="vx-card">
    <h4 class="pl-8 pt-6" v-if="title">{{ title }}</h4>

    <div class="p-8">
      <div class="flex flex-wrap justify-between">
        <div class="flex">
          <vs-dropdown class="cursor-pointer" vs-trigger-click>
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium mr-2">
              <span>
                {{ currentPage * paginationPageSize - (paginationPageSize - 1) }} -
                {{ userData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : userData.length }} of {{
                  totalUsers
                }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10); loadProductBuffer();">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20); loadProductBuffer();">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(50); loadProductBuffer();">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(100); loadProductBuffer();">
                <span>100</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(150); loadProductBuffer();">
                <span>150</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <vs-button color="primary" class="ml-2 round" type="gradient"
                     @click="selectUserCreateTypePopup = !selectUserCreateTypePopup">Create New User
          </vs-button>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <div class="flex items-center">
          <vs-input @input="updateSearchQuery" @keydown.esc="showArchived = !showArchived; loadProductBuffer();"
                    class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                    placeholder="Search..." v-model="searchQuery"/>
          <vs-button color="primary" icon-pack="feather" icon="icon-filter" class=""
                     type="gradient" @click="filterPopup = !filterPopup">Open Filter
          </vs-button>
        </div>
      </div>


      <!-- AgGrid Table -->
      <ag-grid-vue
        :animateRows="true"
        :columnDefs="columnDefs"
        :components="components"
        :defaultColDef="defaultColDef"
        :enableRtl="$vs.rtl"
        :floatingFilter="true"
        :gridOptions="gridOptions"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :rowData="userData"
        :suppressPaginationPanel="true"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        colResizeDefault="shift"
        ref="agGridTable">
      </ag-grid-vue>

      <vs-pagination :total="totalPages" v-model="currentPage"/>

      <vs-popup :active.sync="selectUserCreateTypePopup" title="Select Action">
        <div class="vx-row mb-2">
          <div class="vx-col w-1/2 hover:text-primary cursor-pointer" @click="uploadUsers">
            <div class="border border-solid m-3 p-6 rounded">
              <div class="flex items-center justify-center">
                <feather-icon icon="UploadIcon" svgClasses="h-16 w-16"/>
              </div>
              <h2 class="text-center mt-4">Upload Multiple<br>Users</h2>
            </div>
          </div>
          <div class="vx-col w-1/2 hover:text-primary cursor-pointer"
               @click="createNewUserActive = true; selectUserCreateTypePopup = false;">
            <div class="border border-solid m-3 p-6 rounded">
              <div class="flex items-center justify-center">
                <feather-icon icon="UserPlusIcon" svgClasses="h-16 w-16"/>
              </div>
              <h2 class="text-center mt-4">Create Single<br>User</h2>
            </div>
          </div>
        </div>
      </vs-popup>
      <vs-popup :active.sync="createNewUserActive" title="Create New User" id="RegUserPopup">
        <vs-input v-model="createNewUserValues.first_name" class="mb-8 w-full" label-placeholder="First Name"/>
        <vs-input v-model="createNewUserValues.last_name" class="mb-8 w-full" label-placeholder="Last Name"/>
        <vs-input v-model="createNewUserValues.username" class="mb-8 w-full" v-validate="'required|username|min:3'"
                  label-placeholder="Username"/>
        <vs-input v-model="createNewUserValues.password" class="mb-6 w-full" label-placeholder="Password"/>
        <div class="flex mb-6 align-middle items-center">
          <p class="mr-2">Activate Account</p>
          <vs-switch v-model="createNewUserValues.active" class="ml-2"/>
        </div>

        <vs-button color="success" type="filled" @click="createAccount">Create Account</vs-button>
      </vs-popup>
      <vs-popup :active.sync="filterPopup" title="Users Filter" id="UserFilterPopup">
        <vs-input v-model="searchQuery" @input="updateSearchQuery()" class="my-4 mt-5 w-full"
                  size="large" label-placeholder="User Search"/>
        <vx-card class="my-4" v-if="filterGroups">
          <div class="vx-row" v-if="filterSearchGroupsSelected">
            <div class="vx-col w-1/5 hidden md:flex items-center align-middle">
              <vs-avatar :color="filterSearchGroupsSelected.color"
                         :text="filterSearchGroupsSelected.name.charAt(0).toUpperCase()" class="flex-shrink-0 font-bold"
                         size="80px"/>
            </div>
            <div class="vx-col w-5/5 md:w-4/5 flex items-center align-middle ">
              <div class="my-2">
                <h5 class="mb-2">{{ filterSearchGroupsSelected.name }}</h5>
                <div class="text-small text-danger cursor-pointer flex items-center" @click="filterGroupRemove()">
                  <feather-icon icon="XIcon" svgClasses="h-5 w-5 mr-1"/>
                  Remove Filter
                </div>
              </div>
            </div>
          </div>
          <div class="flex justify-between items-center" v-else>
            <h2>No Group Filtered</h2>
            <vs-button color="primary" type="gradient" @click="filterPopup = false; filterSearchGroupsPopup = true;"
                       icon-pack="feather"
                       icon="icon-user-add">Select Group
            </vs-button>
          </div>
        </vx-card>
        <vs-button color="primary" type="gradient" @click="filterPopup = false;" class="mt-8">Close</vs-button>
      </vs-popup>
      <vs-popup :active.sync="filterSearchGroupsPopup" classContent="popup-example" title="Search for Group by Name">
        <vs-table :data="filterSearchGroupsResults" :sst="true" max-items="5" search @search="filterSearchGroups">
          <template slot="header">
            <h3>Groups</h3>
          </template>

          <template slot="thead">
            <vs-th>ID</vs-th>
            <vs-th>Name</vs-th>
            <vs-th>Action</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr v-for="(attach) in data" :key="attach.id">

              <vs-td :data="attach.id">
                {{ attach.id }}
              </vs-td>

              <vs-td :data="`${attach.name}`">
                <div class="flex align-middle items-center">
                  <vs-avatar :color="attach.color" :text="attach.name.charAt(0).toUpperCase()"
                             class="flex-shrink-0 mr-2" size="30px"/>
                  {{ `${attach.name}` }}
                </div>
              </vs-td>

              <vs-td>
                <vs-button color="primary" size="small" type="border" icon-pack="feather" icon="icon-filter"
                           @click="filterGroupsSelected(attach)">
                  Filter
                </vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vs-popup>
    </div>

  </div>
</template>

<script>
import TableName from './components/TableName.vue'
import TableActions from './components/TableActions.vue'
import TableGroup from './components/TableGroup.vue'
import TableID from './components/TableID'
import {AgGridVue} from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'


export default {
  components: {
    AgGridVue,
    vSelect,
    TableName,
    TableActions,
    TableGroup,
    TableID
  },
  props: {
    title: {
      type: String,
      default: '',
      required: false
    },
    groupId: {
      type: String,
      default: '',
      required: false
    },
    filterGroups: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  data () {
    return {

      showArchived: false,

      userData: [],
      totalUsers: 0,

      searchQuery: '',

      selectUserCreateTypePopup: false,

      createNewUserActive: false,
      createNewUserValues: {
        first_name: '',
        last_name: '',
        username: '',
        password: '',
        active: true
      },

      filterPopup: false,

      filterSearchGroupsPopup: false,
      filterSearchGroupsResults: [],
      filterSearchGroupsSelected: null,


      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        valueFormatter: (params) => {
          if (typeof params.value === 'string') {
            const value = params.value
            return value.charAt(0).toUpperCase() + value.slice(1)
          }

          return params
        }
      },

      columnDefs: [
        {
          headerName: 'ID',
          field: 'id',
          filter: true,
          width: 300,
          cellRendererFramework: 'TableID'
        },
        {
          headerName: 'Name',
          field: 'name',
          filter: true,
          width: 400,
          cellRendererFramework: 'TableName'
        },
        {
          headerName: 'Username',
          field: 'username',
          filter: true
        },
        {
          headerName: 'Groups',
          cellRendererFramework: 'TableGroup',
          field: 'groups',
          filter: true
        },
        {
          headerName: 'Actions',
          width: 150,
          sortable: false,
          cellRendererFramework: 'TableActions',
          cellRendererParams: {
            loadProductBuffer: this.loadProductBuffer.bind(this)
          }
        }
      ],

      // Cell Renderer Components
      components: {
        TableName,
        TableActions,
        TableGroup,
        TableID
      },
      totalPages: 0
    }
  },
  watch: {
    'createNewUserValues.first_name' () {
      this.createNewUserValues.username = `${this.createNewUserValues.first_name.toLowerCase() + this.createNewUserValues.last_name.toLowerCase()  }`
      // this.createNewUserValues.password = `student${  this.createNewUserValues.first_name.toLowerCase()  }2021`
      this.createNewUserValues.password = 'student12345'
    },
    'createNewUserValues.last_name' () {
      this.createNewUserValues.username = `${this.createNewUserValues.first_name.toLowerCase() + this.createNewUserValues.last_name.toLowerCase() }`
    }
  },
  computed: {
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
        this.loadProductBuffer(val)
      }
    }
  },
  methods: {
    uploadUsers () {
      this.selectUserCreateTypePopup = false
      setTimeout(() => {
        this.$router.push('/a/users/upload')
      }, 10)
    },
    createAccount () {

      const pl = {
        username: this.createNewUserValues.username,
        password: this.createNewUserValues.password,
        first_name: this.createNewUserValues.first_name,
        last_name: this.createNewUserValues.last_name,
        active: this.createNewUserValues.active
      }

      this.createNewUserActive = false

      this.$http.post('auth/register', pl)
        .then(response => {
          this.$vs.loading.close()
          const userId = response.data.data.id
          if (response.status === 200) {
            this.$router.push(`/a/users/${userId}`)
            return this.$vs.notify({
              color: 'success',
              title: 'Account Created',
              text: 'You have successfully created a account',
              icon: 'feather',
              iconPack: 'icon-check-circle',
              position: 'top-right'
            })
          }

        }).catch(exception => {
          this.$vs.loading.close()
          return this.$vs.notify({
            color: 'danger',
            title: 'Failed to create Account',
            text: exception.response.data.error.description,
            icon: 'feather',
            iconPack: 'icon-x-circle',
            position: 'top-right'
          })
        })

    },
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = {type: 'equals', filter: val}
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    updateSearchQuery () {
      this.currentPage = 0
    },
    loadProductBuffer (page = 0) {

      if (page === 0) {
        page = this.currentPage
      }

      this.$http.get(`users/count?amount=${this.paginationPageSize}&search=${this.searchQuery}&group=${this.groupId}`)
        .then(response => {
          if (response.data.data) {

            const data = response.data.data

            if (data.pages) {
              this.totalPages = data.pages
              this.totalUsers = data.total
            }

          }
        })
        .catch(() => {
        })

      this.$http.get(`users?amount=${this.paginationPageSize}&page=${page}&archived=${this.showArchived}&search=${this.searchQuery}&group=${this.groupId}`)
        .then(response => {
          if (response.data.data) {
            this.userData = response.data.data
          }

          this.userData = this.userData.map(user => {
            user.name = `${user.first_name} ${user.last_name}`
            const pictureId = user.profile_picture || 'default'
            user.photoURL = `https://portal-cdn.rapid.education/profile-pictures/${pictureId}.jpeg`
            return user
          })

          this.gridApi.sizeColumnsToFit()
        })
        .catch(exception => {

          let error = 'An unknown error occurred while loading the user list'
          if (exception.response) {
            error = exception.response.data.error.description
          }

          return this.$vs.notify({
            title: 'Failed to load user list',
            text: error,
            color: 'danger',
            position: 'top-right'
          })
        })
    },
    filterSearchGroups (term) {
      this.$http.get(`groups?search=${term}&amount=5`)
        .then(response => {
          if (response.data) {
            this.filterSearchGroupsResults = response.data.data
          }
        })
    },
    filterGroupsSelected (group) {
      this.filterSearchGroupsSelected = group
      this.groupId = group.id
      this.filterPopup = true
      this.filterSearchGroupsPopup = false
      this.loadProductBuffer()
    },
    filterGroupRemove () {
      this.groupId = ''
      this.filterSearchGroupsSelected = null
      this.loadProductBuffer()
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api

    if (this.filterGroups) {
      this.filterSearchGroups('')
    }

    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${String(Number(header.style.transform.slice(11, -3)) + 9)}px`
    }
  }
}

</script>
<style lang="scss">


.theme-midnight {
  #UserFilterPopup {
    input.vs-inputx.vs-input--input {
      background: #050056!important;
      border: 1px solid #ffffff!important;

      &:focus {
        border: 1px solid rgba(var(--vs-primary),1)!important;
      }
    }
  }
  #RegUserPopup{
    input.vs-inputx.vs-input--input {
      background: #050056!important;
      border: 1px solid #ffffff!important;

      &:focus {
        border: 1px solid rgba(var(--vs-primary),1)!important;
      }

    }
  }
}

.theme-dark {
  #UserFilterPopup {
    input.vs-inputx.vs-input--input {
      background: #1B1E22!important;
      border: 1px solid #ffffff!important;

      &:focus {
        border: 1px solid rgba(var(--vs-primary),1)!important;
      }
    }
  }
  #RegUserPopup{
    input.vs-inputx.vs-input--input {
      background: #1B1E22!important;
      border: 1px solid #ffffff!important;

      &:focus {
        border: 1px solid rgba(var(--vs-primary),1)!important;
      }

    }
  }
}


</style>
